import { CallcardFormatterService } from '@addins/core/core';
import { Injectable } from '@angular/core';
import { SagaDatePipe } from '@app/pipes/saga-date/saga-date.pipe';
import { UnitActivity } from '@models/imported/SagaSchema/UnitActivity';
import { TranslateService } from '@ngx-translate/core';
import { registerModelFactory } from '@services/model-factory';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { FusCallcardFormatter } from '../../fus-callcard-formatter/fus-callcard-formatter.service';
import { UnitActivityFusModelService } from '../../models/unit-activity-fus-model/unit-activity-fus-model.service';
import { MyCardReceivedTimeService } from '../../my-card-received-time/mycard-received-time.service';

@AddinExecute({
  name: 'FusCallcardFormatter setup'
})
@Injectable()
export class FusCallcardFormatterSetupService extends Execute {
  constructor(
    private callcardFormatter: CallcardFormatterService,
    private translate: TranslateService,
    private sagaDate: SagaDatePipe,
    private myCardReceivedTime: MyCardReceivedTimeService
  ) {
    super();
  }

  execute() {
    registerModelFactory(UnitActivityFusModelService, UnitActivity);

    this.callcardFormatter.setFormatter(new FusCallcardFormatter(this.translate, this.sagaDate, this.myCardReceivedTime));
  }
}
